import React, { useState, useRef, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, parseClasses } from '../../lib/ep.js';

import FieldLabel from './FieldLabel';

const TimeCounterSimple = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ time, setTime ] = useState({});
	const [ init, setInit ] = useState(false);

	const execute_countdown = props?.execute_countdown ?? true;
	
	const timer = useRef(0);

	const hide_days = useRef(props?.hide_days ?? false);
	const hide_hours = useRef(props?.hide_hours ?? false);
	const hide_minutes = useRef(props?.hide_minutes ?? false);
	const hide_seconds = useRef(props?.hide_seconds ?? false);

	const addPreZeros = (_value) => {
		const value = Math.max(parseInt(_value), 0);
		if(value >= 10) return value;
		return `0${value}`;
	};

	const exit = (execute_cb) => {
		if(execute_cb == undefined) execute_cb = false;

		if(timer.current != undefined) {
			clearInterval(timer.current);
		}

		if(execute_cb && props.onFinish != undefined) props.onFinish();
	};

	const secondsToTime = (s) => {
		const divisor_for_hours = s % (24 * 60 * 60);
		const divisor_for_minutes = s % (60 * 60);
		const divisor_for_seconds = divisor_for_minutes % 60;

		// Values without pre-zeros (so they can be used in "custom_render" mode):
		const d2 = Math.floor(s / (24 * 60 * 60));
		const h2 = Math.floor(divisor_for_hours / (60 * 60));
		const m2 = Math.floor(divisor_for_minutes / 60);
		const s2 = Math.floor(divisor_for_seconds);

		setTime({
			d2,
			d:addPreZeros(d2),
			h2,
			h:addPreZeros(h2),
			m2,
			m:addPreZeros(m2),
			s2,
			s:addPreZeros(s2),
		});

		if(execute_countdown) {
			if(s > 0) {
				setTimeout(() => {
					secondsToTime(s - 1);
				}, 1000);
			} else {
				exit(true);
			}
		}
	};

	useEffect(() => {
		secondsToTime(parseInt(props?.seconds ?? 10));
		setInit(true);
		
		return () => {
			exit(false);
		}
	}, [props.seconds]);

	if(!init) return null;

	const custom_render = props?.custom_render ?? false;

	let classname = props?.classname ?? 'simple_countdown';
	classname = parseClasses(classname, props._class, 'timecounter');
	if(props?._hidden ?? false) classname += 'hidden';

	let countdown_classes = ['timer'];
	if(props.is_alone != undefined && props.is_alone) countdown_classes.push('gui_in_start');

	const inlined_label = props?.inlined_label ?? false;

	return (
		<div class={classname}>
			{(props.children != undefined) && (
				<FieldLabel
					{...props.label_props}
					name={props.name}
					autotranslate={props.autotranslate}
				>{props.children}</FieldLabel>
			)}

			{(!custom_render) && (
				<div class={countdown_classes.join(" ")}>
					{(inlined_label && inlined_label != "") && (
						<span class="block is_label">{i18n(inlined_label)}</span>
					)}

					{(!hide_days.current) && (
						<span class="block is_days">
							<strong class="v">{time.d}</strong>
							<em class="u">{i18n("d")}</em>
						</span>
					)}

					{(!hide_hours.current) && (
						<span class="block is_hours">
							<strong class="v">{time.h}</strong>
							<em class="u">{i18n("h")}</em>
						</span>
					)}

					{(!hide_minutes.current) && (
						<span class="block is_minutes">
							<strong class="v">{time.m}</strong>
							<em class="u">{i18n("m")}</em>
						</span>
					)}

					{(!hide_seconds.current) && (
						<span class="block is_seconds">
							<strong class="v">{time.s}</strong>
							<em class="u">{i18n("s")}</em>
						</span>
					)}
				</div>
			)}

			{(custom_render) && (
				<div
					class={countdown_classes.join(" ")}
					dangerouslySetInnerHTML={{ __html:props.intl.formatMessage({ id:custom_render }, { ...time }) }}
				/>
			)}
		</div>
	)
}

export default injectIntl(TimeCounterSimple);